
import { renderToString } from 'preact-render-to-string';
import { MwlIcons } from "../components/MwlIcons";
import { SocialSharingOptions } from "../components/SocialSharingOptions";

import i18n from '@i18n';

export const initSocialSharing = (lightbox) => {
  const shareIcon = <MwlIcons icon={'sharing'} />;

  lightbox.on('uiRegister', () => {
    lightbox.pswp.ui.registerElement({
      name: 'social-share-button',
      ariaLabel: i18n.TOOLBAR.SHARE,
      order: 10,
      isButton: true,
      html: renderToString(shareIcon),
      onInit: (el) => {
        el.dataset.tooltip = i18n.TOOLBAR.SHARE;
      },
      onClick: (event, el) => {
        const containerParent = el.closest('.pswp__scroll-wrap');
        const url = window.location.href;
        SocialSharingOptions.render(containerParent, url);
      },
    });
  });
};